import { Checkbox, Col, Flex, Form, Row } from 'antd'

import { MedicalAssistanceType } from 'src/api/requests'
import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

export const GeneralServices = () => {
  const { t } = useLocales()

  const medicalAssistance = Object.values(MedicalAssistanceType)

  return (
    <Form.Item name="medicalAssistanceTypes" rules={requiredRules}>
      <Checkbox.Group>
        <Row gutter={[24, 8]}>
          {medicalAssistance.map((item) => (
            <Col xs={24} key={item}>
              <Flex align="center" justify="space-between">
                <Checkbox value={item}>
                  {t(`medical_assistance.${item}`)}
                </Checkbox>
              </Flex>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    </Form.Item>
  )
}
